import Header from '../../components/Header/Header';
import AdminWaybillsList from '../../components/AdminWaybillsList/AdminWaybillsList';
import AdminNavigation from '../../components/AdminNavigation/AdminNavigation';
import './admin.css';

function AdminWaybillsPage() {
  return (
    <>
      <Header />
      <AdminNavigation />
      <div className="admin__container">
        <div className="admin__container-wrapper">
          <AdminWaybillsList />
        </div>
      </div>
    </>
  );
}

export default AdminWaybillsPage;
